import { MeshBasicMaterial, Mesh, MathUtils } from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { Context3DConfig } from '#server/models';
import { useModel } from '@/hooks';

export const ReferenceContext = function ({
  modelPath,
  config
}: {
  modelPath: string;
  config: Context3DConfig['referenceContext'];
}) {
  const referenceContext = useModel(FBXLoader, modelPath, 'referenceContext');

  referenceContext.traverse((child) => {
    if (child.type === 'Mesh') {
      const mesh = child as Mesh;
      mesh.material = new MeshBasicMaterial({
        wireframe: true,
        color: 0xc3d82e,
        transparent: true,
        opacity: 0.1
      });
    }
  });

  return (
    <primitive
      scale={config.scale}
      position={config.position}
      rotation={[
        MathUtils.degToRad(config.rotation[0]),
        MathUtils.degToRad(config.rotation[1]),
        MathUtils.degToRad(config.rotation[2])
      ]}
      object={referenceContext}
    />
  );
};
